const mutaitons = {
  // 改变子菜单
  changeChilrenMenu: (state, data) => {
    state.menuChildrenList = data;
  },
  // 改变登录状态
  login:(state,data) => {
	  state.isLogin = data;
  },
  // 设置按钮权限
  setPermission:(state,data) => {
  	  state.permission = data;
  },
};
export default mutaitons;



// WEBPACK FOOTER //
// ./src/store/mutations.js